import { useEffect, useState } from "react";
import { useGetMasterUsers } from "../../api/v1";
import { SelectOption } from "../../types/select";

type UsePropertyAdminOptions = {
  isEnabled?: boolean;
};

export const usePropertyAdminOptions = (options: UsePropertyAdminOptions = {}) => {
  const { isEnabled } = options;
  const [propertyAdminOptions, setPropertyAdminOptions] = useState<SelectOption[]>([]);

  const { masterUsers, isLoadingMasterUsers } = useGetMasterUsers({ isEnabled });

  useEffect(() => {
    if (!isEnabled) return;

    const options = masterUsers.map((item) => ({
      label: item.name,
      value: item.name,
    }));

    setPropertyAdminOptions(options);
  }, [isEnabled, masterUsers]);

  return { propertyAdminOptions, isLoadingMasterUsers };
};
